import { format } from 'date-fns';
import { LIMITE_IMAGEM_KB } from '../../utils/validarImagem';
import { UsoDoArquivo } from './models';

const NOMES_DOS_TENANTS: Record<string, string> = {
  default: 'Preço Popular',
  drogaria_cat: 'Drogaria Catarinense',
};

// Nomes amigáveis para as relações que a api devolve em "usadoEm"
const NOMES_DOS_USOS: Record<string, string> = {
  groupElements: 'Componente de página',
  configs: 'Configuração',
  categories: 'Categoria',
  ConfigImage: 'Logo',
  menuItemLeft: 'Ícone de menu',
  menuItemRight: 'Ícone de menu',
  bannerFile: 'Banner de menu',
};

export const formatarPeso = (kb: number): string => {
  if (kb < 1024) return `${kb} KB`;
  return `${(kb / 1024).toFixed(1).replace('.', ',')} MB`;
};

export const acimaDoLimite = (kb: number): boolean => kb > LIMITE_IMAGEM_KB;

export const formatarData = (iso: string): string =>
  format(new Date(iso), 'dd/MM/yyyy');

export const descreverUso = (usadoEm: UsoDoArquivo): string[] => {
  const totais = new Map<string, number>();

  Object.entries(usadoEm).forEach(([relacao, quantidade]) => {
    if (!quantidade) return;
    const nome = NOMES_DOS_USOS[relacao] ?? relacao;
    totais.set(nome, (totais.get(nome) ?? 0) + quantidade);
  });

  return Array.from(totais, ([nome, quantidade]) => `${quantidade}× ${nome}`);
};

export const estaEmUso = (usadoEm: UsoDoArquivo): boolean =>
  Object.values(usadoEm).some(quantidade => quantidade > 0);

export const nomeDoTenant = (tenantId: string): string =>
  NOMES_DOS_TENANTS[tenantId] ?? tenantId;

export const tipoDoArquivo = (mimetype: string | null): string => {
  if (!mimetype) return '—';
  return mimetype.replace('image/', '').replace('+xml', '').toUpperCase();
};
